import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';
import { LoginFormContentComponent } from '../form/content/login-form-content.component';
import { LOGIN_VIEW_LAYOUT_CONFIG } from './login-view-layout.config';
import { NLoginViewLayout } from './login-view-layout.interface';

@Component({
    selector: 'login-view-layout',
    templateUrl: './login-view-layout.component.html',
    styleUrl: './login-view-layout.component.scss',
    standalone: true,
    imports: [LoginFormContentComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<LoginViewLayoutComponent>(LOGIN_VIEW_LAYOUT_CONFIG)
export class LoginViewLayoutComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: NLoginViewLayout.IContentData;
}
